export default __webpack_public_path__ + "static/media/pokemon_trainer.5a2f7050.jpg";